import React from 'react';
import { Service, ToolGroup } from 'wax-prosemirror-core';
import { isEmpty } from 'lodash';
import CitationTool from './CitationTool';
import ReferenceManagerTool from './ReferenceManagerTool';
import CitationStyleTool from './CitationStyleTool';
import CitationRefreshTool from './CitationRefreshTool';

class Citations extends ToolGroup {
  constructor(citation, referenceManager, citationStyle, citationRefresh) {
    super();
    this._tools = [citation, referenceManager, citationRefresh, citationStyle];
  }

  renderTools(view) {
    if (isEmpty(view)) return null;
    return (
      <React.Fragment key="citations-tool-group">
        {this._tools[0].renderTool(view)}
        {this._tools[1].renderTool(view)}
        {this._tools[2].renderTool(view)}
        {this._tools[3].renderTool(view)}
      </React.Fragment>
    );
  }
}

class CitationToolGroupService extends Service {
  name = 'Citations';

  register() {
    const config = this.container.get('Config');
    const pmplugins = this.container.get('PmPlugins');

    const citation = new CitationTool(config, pmplugins);
    const referenceManager = new ReferenceManagerTool(config, pmplugins);
    const citationStyle = new CitationStyleTool(config, pmplugins);
    const citationRefresh = new CitationRefreshTool(config, pmplugins);

    // Manually inject container as decorators are disabled in this environment
    citation.container = this.container;
    referenceManager.container = this.container;
    citationStyle.container = this.container;
    citationRefresh.container = this.container;

    const citationsToolGroup = new Citations(citation, referenceManager, citationStyle, citationRefresh);

    this.container.bind('Citations').toConstantValue(citationsToolGroup);
  }
}

export default CitationToolGroupService;


